<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="fm_h1"><span epub:type="pagebreak" id="page_vii" title="vii"><span epub:type="pagebreak" id="page_viii" title="viii">CONTENTS</span></span></p>
<p class="toc_fm"><a id="r_int"></a><a href="#/text/Introduction#int">Introduction</a></p>
<p class="toc_fm1"><a href="#/text/Introduction#int"><i>Three Midwestern Playwrights and the Provincetown Players</i></a></p>
<p class="toc_ch1"><a id="r_ch1"></a><a href="#/text/Chapter01#ch1">1. Three Midwestern Playwrights Discover the New</a></p>
<p class="toc_ch1"><a id="r_ch2"></a><a href="#/text/Chapter02#ch2">2. Three Midwestern Playwrights Arrive in a Romantic and Miraculous City</a></p>
<p class="toc_ch1"><a id="r_ch3"></a><span href="#/text/Chapter03#ch3" title="Link target outside of Sample">3. Floyd Dell Embraces Feminism in Port Royal</span></p>
<p class="toc_ch1"><a id="r_ch4"></a><span href="#/text/Chapter04#ch4" title="Link target outside of Sample">4. George Cram Cook Runs for Congress in the Red City of Iowa</span></p>
<p class="toc_ch1"><a id="r_ch5"></a><span href="#/text/Chapter05#ch5" title="Link target outside of Sample">5. Susan Glaspell Fights for Free Speech in Freeport</span></p>
<p class="toc_ch1"><a id="r_ch6"></a><span href="#/text/Chapter06#ch6" title="Link target outside of Sample">6. Three Midwestern Playwrights Found a Theatre Company</span></p>
<p class="toc_fm"><a id="r_con"></a><span href="#/text/Conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc_fm1"><span href="#/text/Conclusion#con" title="Link target outside of Sample"><i>Three Midwestern Playwrights Venture beyond P-Town</i></span></p>
<p class="toc_fm2"><a id="r_ack"></a><span href="#/text/Acknowledgments#ack" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="toc_fm"><a id="r_abb"></a><span href="#/text/Abbreviations#abb" title="Link target outside of Sample"><i>Abbreviations</i></span></p>
<p class="toc_fm"><a id="r_note"></a><span href="#/text/Notes#note" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc_fm"><a id="r_manu"></a><span href="#/text/Manscript#manu" title="Link target outside of Sample"><i>Manuscript Collections Consulted</i></span></p>
<p class="toc_fm"><a id="r_epi"></a><span href="#/text/Sources#epi" title="Link target outside of Sample"><i>Sources for Chapter Epigraphs</i></span></p>
<p class="toc_fm"><a id="r_work"></a><span href="#/text/Work_Cited#work" title="Link target outside of Sample"><i>Works Cited and Consulted</i></span></p>
<p class="toc_fm"><a id="r_cook"></a><span href="#/text/George#cook" title="Link target outside of Sample"><i>Classified Primary Source Bibliographies Compiled by Tyler Preston</i></span></p>
<p class="toc_fm1"><span href="#/text/George#cook" title="Link target outside of Sample"><i>George Cram Cook</i></span></p>
<p class="toc_fm1"><a id="r_gla"></a><span href="#/text/Susan#gla" title="Link target outside of Sample"><i>Susan Glaspell</i></span></p>
<p class="toc_fm1"><a id="r_fly"></a><span href="#/text/Flyed_Dell#fly" title="Link target outside of Sample"><i>Floyd Dell</i></span></p>
<p class="toc_fm"><a id="r_ind"></a><span href="#/text/Index#ind" title="Link target outside of Sample"><i>Index</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6ac49ba7